module.exports = __webpack_public_path__ + "resources/icon_50_more.c7e7fd92440a0572.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_more.png
// module id = 446
// module chunks = 0 1 2 3 4